import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export default function useObjectTranslation() {
  const { t } = useTranslation()

  return useCallback(
    (itemId, propertyOrPath, defaultValue = '') => {
      if (!itemId) return defaultValue

      const translatedObject = t(itemId, { returnObjects: true })
      const path = Array.isArray(propertyOrPath) ? propertyOrPath : propertyOrPath.split('.')

      return path.reduce((obj, key) => obj?.[key], translatedObject) ?? defaultValue
    },
    [t]
  )
}
